module.exports = __webpack_public_path__ + "static/img/bgimg.8224b35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/libs/bgimg.jpg
// module id = V72X
// module chunks = 0